import type { ApiProduct } from '../../../../../models/ecommerce/product/ApiProduct';

import { useProductSearchStateContext } from '../../../../search/hooks/useProductSearchStateContext';
import NoEcommerceSearchOverlayResults from '../EcommerceSearchOverlay/NoEcommerceSearchOverlayResults';
import CheckoutOverlayResultContent from './CheckoutOveralyResultContent';

const CheckoutOverlayResultList = (props: {
    onFullResultsClick: () => void;
    onHintClick: (hint: string) => void;
    onItemAddToCartClick: (item: ApiProduct, index: number) => void;
    onItemRemoveFromCartClick: (item: ApiProduct, index: number) => void;
}) => {
    const { result, query, queryUsed, isLoading } = useProductSearchStateContext();

    const hasResults = !!result && result.items.length > 0;
    const hasNoResults = !!result && result.items.length === 0;

    return (
        <>
            {hasResults && (
                <CheckoutOverlayResultContent
                    onFullResultClick={props.onFullResultsClick}
                    onItemAddToCartClick={props.onItemAddToCartClick}
                    onItemRemoveFromCartClick={props.onItemRemoveFromCartClick}
                    result={result}
                    query={query}
                    queryUsed={queryUsed}
                />
            )}
            {hasNoResults && (
                <NoEcommerceSearchOverlayResults
                    isLoading={isLoading}
                    query={query}
                    queryUsed={queryUsed}
                    onHintClick={props.onHintClick}
                />
            )}
        </>
    );
};

export default CheckoutOverlayResultList;
